module.exports = __webpack_public_path__ + "img/dbb4e21.jpg";